<h2 class="text-center mb-4">Email confirmation</h2>
<p *ngIf="isResendError && resendMsg" class="alert alert-warning font-weight-bold text-center" role="alert">{{resendMsg}}</p>
<form *ngIf="!confirmemail; else emailSent" [formGroup]="resendForm" name="resendForm" class="m-0" (ngSubmit)="OnSubmit()">
  <div class="fieldset">
    <label for="email" class="legend">Email</label>
    <input type="email" name="email" id="email" class="text-field" formControlName="email" autocomplete="email" required>
    <div class="formError" *ngIf="resendForm.get('email')?.invalid && resendForm.get('email')?.touched">
      <span *ngIf="resendForm.get('email')?.hasError('required')">Email is required</span>
      <span *ngIf="resendForm.get('email')?.hasError('email')">Enter a valid email</span>
    </div>
  </div>
  <button *ngIf="!isLoading; else sendingEmail" type="submit" class="btn" [disabled]="this.resendForm.invalid">Resend verification email</button>
  <ng-template #sendingEmail>
    <button class="btn btn--loading" type="button">Sending email...</button>
  </ng-template>
</form>
<ng-template #emailSent>
  <p class="alert alert-success font-weight-bold text-center" role="status">Email sent. Please verify your account by clicking the verification link sent to your email.</p>
  <p class="text-links-wrap"><a routerLink="/access/login" class="text-link m-auto">Back to login</a></p>
</ng-template>
